import React from "react";
import { Link } from "react-router-dom";

import "./About.css";

import LinaImage from "./Images/Lina.jpg";

export default function About() {
  return (
    <div className="About">
      <div className="content-container container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="content">
              <h1 className="mb-4">Hi, I am Lina Moramaga</h1>

              <h2 className="mb-4">
                Junior Front-end Developer, based in South Africa
              </h2>

              <p className="mb-4">
                I am a Junior Front-end Developer based in South Africa,
                specialising in building responsive and user-friendly websites
                using React, JavaScript, Bootstrap and modern web technologies.
                I enjoy transforming ideas into clean, functional interfaces
                while continuously improving my development skills.
              </p>

              <div className="skills mt-5">
                <h3>Skills & Technologies</h3>
                <div className="skills-list">
                  <span>HTML5</span>
                  <span>CSS3</span>
                  <span>JavaScript</span>
                  <span>React.js</span>
                  <span>Bootstrap</span>
                  <span>Responsive Design</span>
                  <span>API Integration</span>
                </div>

                <h3 className="mt-4">Tools</h3>
                <div className="skills-list">
                  <span>VS Code</span>
                  <span>Git</span>
                  <span>GitHub</span>
                  <span>Chrome DevTools</span>
                  <span>Figma</span>
                </div>

                <h3 className="mt-4">Fun Fact</h3>
                <p>
                  When I am not coding, I enjoy learning new technology,
                  improving my skills, and finding creative solutions to
                  everyday problems. 🚀
                </p>
              </div>

              <Link to="/work" className="btn btn-branding mt-4">
                View all projects
              </Link>
            </div>
          </div>

          <div className="col-lg-6">
            <img
              src={LinaImage}
              alt="Lina Moramaga"
              className="img-fluid rounded"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
